module.exports = __webpack_public_path__ + "assets/img/4ccc79e3e08764a17e5cb9eadc81af78.svg";